export enum Energieart {
    UNKNOWN = 'UNKNOWN',
    WIND = 'WIND',
    GASE_BIOMASSE = 'GASE_BIOMASSE',
    WASSER = 'WASSER',
    SOLAR = 'SOLAR',
    BHKW = 'BHKW',
    GEOTHERMIE = 'GEOTHERMIE'
}

export class EnergieartItem {

    public key: string;
    public description: string;

    constructor(key: string, description: string) {
        this.key = key;
        this.description = description;
    }

    public static getAll(): EnergieartItem[] {
        return [
            new EnergieartItem(Energieart.WIND, 'Windenergie'),
            new EnergieartItem(Energieart.GASE_BIOMASSE , 'Deponie-/Gruben-/Klärgas, Biomasse'),
            new EnergieartItem(Energieart.WASSER , 'Wasserkraft'),
            new EnergieartItem(Energieart.SOLAR , 'Solarenergie'),
            new EnergieartItem(Energieart.BHKW , 'BHKW-/IKWAnlagen'),
            new EnergieartItem(Energieart.GEOTHERMIE , 'Geothermie'),
            new EnergieartItem(Energieart.UNKNOWN, 'Sonstige'),
        ];
    }

}

